import React from "react";

export default function EmptyState({ message, emoji = "🔍", action }: { message: string; emoji?: string; action?: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-gray-500" role="status" aria-live="polite">
      <div className="text-6xl mb-4">{emoji}</div>
      <div className="text-lg font-semibold mb-2">{message}</div>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
} 